import { IFilterBarProps } from './filter-bar.types';
import styles from './filter-bar.module.css';
import { useSearchParams } from 'react-router-dom';
import { Input } from 'shared-components';
import { Label } from 'shared-components';
import { Checkbox } from 'shared-components';
import { CheckboxList } from 'shared-components';
import { FormGroup } from 'shared-components';
import { FormLayout } from 'shared-components';

export const FilterBar = ({
  value,
  filters,
  onSearch,
  onFilterChanged,
}: IFilterBarProps) => {
  const [, setSearchParams] = useSearchParams();
  return (
    <FormLayout className={styles.filterBar}>
      <div>
        {filters?.map((filter) => (
          <CheckboxList
            key={filter.key}
            label={filter.title}
            direction="horizontal"
          >
            {filter.options.map((option) => (
              <Checkbox
                key={option.value}
                type={filter.multiple ? 'checkbox' : 'radio'}
                checked={
                  filter.multiple
                    ? (value[filter.key]?.indexOf(option.value) ?? -1) > -1
                    : value[filter.key] === option.value
                }
                name={`filter_${filter.key}`}
                value={option.value}
                onClick={(evt) => {
                  if (filter.multiple) {
                    const vArray = value[filter.key] as string[];
                    const values =
                      vArray?.filter((v) => v !== option.value) ?? [];
                    if ((evt.target as HTMLInputElement).checked) {
                      values.push(option.value);
                    }
                    onFilterChanged?.(filter, values);
                    setSearchParams({
                      [filter.key]: values,
                    });
                  } else {
                    onFilterChanged?.(filter, option.value);
                    setSearchParams({
                      [filter.key]: option.value,
                    });
                  }

                  // onFilterChanged?.(values);
                }}
                label={option.display}
              />
              // <Label key={option.value} className={styles.filterOption}>
              //   <input
              //     type={filter.multiple ? 'checkbox' : 'radio'}
              //     onClick={(evt) => {
              //       if (filter.multiple) {
              //         const vArray = value[filter.key] as string[];
              //         const values =
              //           vArray?.filter((v) => v != option.value) ?? [];
              //         if ((evt.target as HTMLInputElement).checked) {
              //           values.push(option.value);
              //         }
              //         onFilterChanged?.(filter, values);
              //         setSearchParams({
              //           [filter.key]: values,
              //         });
              //       } else {
              //         onFilterChanged?.(filter, option.value);
              //         setSearchParams({
              //           [filter.key]: option.value,
              //         });
              //       }

              //       // onFilterChanged?.(values);
              //     }}
              //     defaultChecked={
              //       filter.multiple
              //         ? (value[filter.key]?.indexOf(option.value) ?? -1) > -1
              //         : value[filter.key] === option.value
              //     }
              //     name={`filter_${filter.key}`}
              //     value={option.value}
              //   />
              //   {option.display}
              // </Label>
            ))}
          </CheckboxList>
        ))}
      </div>
      {onSearch && (
        <FormGroup className={styles.search}>
          <Label className="sr-only" htmlFor="searchField">
            Search
          </Label>
          <Input
            placeholder="Search"
            onKeyDown={(evt) => {
              if (evt.key === 'Enter') {
                onSearch((evt.target as HTMLInputElement).value);
              }
            }}
            type="text"
            id="searchField"
            name="searchField"
          />
        </FormGroup>
      )}
    </FormLayout>
  );
};
